<div>
  <xpo-footer [version]="build">
    <div class="xpoLogo"></div>
  </xpo-footer>
</div>
